module.exports = __webpack_public_path__ + "static/img/service_bg2.1bb05d45.png";